/**
 * LAURYE — Contemporary Jewelry Theme JavaScript
 * Parfois-Inspired Left Navigation Drawer, Sticky Header, Accordions & Favorites
 */

document.addEventListener('DOMContentLoaded', () => {
  initSideNavDrawer();
  initStickyHeader();
  initProductAccordions();
  initMatchingVariants();
  initProductGallery();
  initStickyATC();
  initQuantityInputs();
  initWishlist();
  initProductRecommendations();
});

// 1. Left-Side Navigation Drawer
function initSideNavDrawer() {
  const toggleBtns = document.querySelectorAll('[data-side-nav-toggle]');
  const drawer = document.querySelector('[data-side-nav-drawer]');
  const backdrop = document.querySelector('[data-side-nav-backdrop]');
  const closeBtn = document.querySelector('[data-side-nav-close]');

  if (!drawer || !backdrop) return;

  const openDrawer = (e) => {
    if (e) e.preventDefault();
    drawer.classList.add('active');
    backdrop.classList.add('active');
    document.body.style.overflow = 'hidden';
  };

  const closeDrawer = () => {
    drawer.classList.remove('active');
    backdrop.classList.remove('active');
    document.body.style.overflow = '';
  };

  toggleBtns.forEach(btn => btn.addEventListener('click', openDrawer));
  backdrop.addEventListener('click', closeDrawer);
  if (closeBtn) closeBtn.addEventListener('click', closeDrawer);

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && drawer.classList.contains('active')) {
      closeDrawer();
    }
  });

  window.openSideNav = openDrawer;
  window.closeSideNav = closeDrawer;
}

// 2. Sticky Header Transition
function initStickyHeader() {
  const header = document.querySelector('[data-site-header]');
  if (!header) return;

  const handleScroll = () => {
    const scrollPos = window.scrollY || window.pageYOffset;
    const triggerHeight = window.innerHeight * 0.7;

    if (scrollPos > triggerHeight) {
      header.classList.add('site-header-sticky');
    } else {
      header.classList.remove('site-header-sticky');
    }
  };

  window.addEventListener('scroll', handleScroll, { passive: true });
  handleScroll();
}

// 3. Product Accordions (Independent & Robust Toggle)
function initProductAccordions() {
  document.addEventListener('click', (e) => {
    const header = e.target.closest('.accordion-header');
    if (!header) return;

    e.preventDefault();
    const item = header.closest('.accordion-item');
    if (!item) return;

    const isActive = item.classList.toggle('active');
    header.setAttribute('aria-expanded', isActive ? 'true' : 'false');
  });
}

// 4. Product Page Gallery Switcher
function initProductGallery() {
  const mainImage = document.querySelector('[data-product-main-image]');
  const thumbs = document.querySelectorAll('[data-product-thumb]');

  if (!mainImage || !thumbs.length) return;

  thumbs.forEach(thumb => {
    thumb.addEventListener('click', () => {
      const newSrc = thumb.getAttribute('data-image-src');
      if (newSrc) {
        mainImage.setAttribute('src', newSrc);
        thumbs.forEach(t => t.classList.remove('active'));
        thumb.classList.add('active');
      }
    });
  });
}

// 5. Mobile Sticky Add to Cart
function initStickyATC() {
  const stickyBar = document.querySelector('[data-sticky-atc-bar]');
  const mainATCBtn = document.querySelector('[data-main-atc-btn]');

  if (!stickyBar || !mainATCBtn) return;

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) {
        stickyBar.classList.add('visible');
      } else {
        stickyBar.classList.remove('visible');
      }
    });
  }, { threshold: 0.1 });

  observer.observe(mainATCBtn);
}

// 6. Quantity Stepper Inputs
function initQuantityInputs() {
  document.addEventListener('click', (e) => {
    const plusBtn = e.target.closest('[data-qty-plus]');
    const minusBtn = e.target.closest('[data-qty-minus]');

    if (plusBtn) {
      e.preventDefault();
      const container = plusBtn.closest('.quantity-stepper');
      if (!container) return;
      const input = container.querySelector('.quantity-input');
      if (input) {
        const currentVal = parseInt(input.value || 1, 10);
        input.value = currentVal + 1;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    if (minusBtn) {
      e.preventDefault();
      const container = minusBtn.closest('.quantity-stepper');
      if (!container) return;
      const input = container.querySelector('.quantity-input');
      if (input) {
        const currentVal = parseInt(input.value || 1, 10);
        if (currentVal > 1) {
          input.value = currentVal - 1;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    }
  });
}

// 7. Wishlist / Favorites System
function initWishlist() {
  const getWishlist = () => {
    try {
      return JSON.parse(localStorage.getItem('laurye_wishlist') || '[]');
    } catch (e) {
      return [];
    }
  };

  const saveWishlist = (list) => {
    localStorage.setItem('laurye_wishlist', JSON.stringify(list));
  };

  const syncButtons = () => {
    const wishlist = getWishlist();
    document.querySelectorAll('[data-wishlist-toggle], .product-wishlist-btn, .product-card-wishlist').forEach(btn => {
      const id = btn.dataset.productId || 'prod-main';
      if (wishlist.includes(id)) {
        btn.classList.add('active');
      } else {
        btn.classList.remove('active');
      }
    });
  };

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-wishlist-toggle], .product-wishlist-btn, .product-card-wishlist');
    if (!btn) return;

    e.preventDefault();
    e.stopPropagation();

    const id = btn.dataset.productId || 'prod-main';
    const title = btn.dataset.productTitle || 'Peça';
    let wishlist = getWishlist();

    if (wishlist.includes(id)) {
      wishlist = wishlist.filter(item => item !== id);
      btn.classList.remove('active');
      window.showToast(`"${title}" removida dos favoritos.`);
    } else {
      wishlist.push(id);
      btn.classList.add('active');
      window.showToast(`"${title}" adicionada aos favoritos! ♥`);
    }

    saveWishlist(wishlist);
    syncButtons();
  });

  syncButtons();
}

// 8. Toast notification helper
window.showToast = function(message) {
  let toast = document.querySelector('.toast-notification');
  if (!toast) {
    toast = document.createElement('div');
    toast.className = 'toast-notification';
    toast.innerHTML = `<span style="color: var(--color-primary-accent); font-weight: bold;">♥</span> <span class="toast-text">${message}</span>`;
    document.body.appendChild(toast);
  } else {
    toast.querySelector('.toast-text').textContent = message;
  }

  toast.classList.add('active');
  setTimeout(() => {
    toast.classList.remove('active');
  }, 3500);
};

// 3b. Matching Edit Add to Cart (Clean, AJAX & Drawer Compatible)
function initMatchingVariants() {
  document.addEventListener('click', async (e) => {
    const atcBtn = e.target.closest('[data-matching-atc]');
    if (!atcBtn || atcBtn.disabled) return;

    e.preventDefault();
    const variantId = atcBtn.getAttribute('data-variant-id');
    const toastMsg = atcBtn.getAttribute('data-toast-msg');

    if (!variantId) {
      if (toastMsg && window.showToast) {
        window.showToast(toastMsg);
      }
      if (window.cartDrawer && typeof window.cartDrawer.open === 'function') {
        window.cartDrawer.open();
      }
      return;
    }

    const originalContent = atcBtn.innerHTML;
    atcBtn.disabled = true;
    atcBtn.classList.add('loading');
    atcBtn.innerHTML = '<span class="spinner-sm"></span>';

    try {
      const formData = new FormData();
      formData.append('id', variantId);
      formData.append('quantity', '1');

      if (window.cartDrawer && typeof window.cartDrawer.addItem === 'function') {
        await window.cartDrawer.addItem(formData);
      } else {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          body: formData
        });
        if (res.ok && window.cartDrawer && typeof window.cartDrawer.refreshCart === 'function') {
          await window.cartDrawer.refreshCart();
          window.cartDrawer.open();
        }
      }

      atcBtn.innerHTML = '<span class="btn-text" style="color: #2e7d32; font-weight: 800;">✓</span>';
      setTimeout(() => {
        atcBtn.innerHTML = originalContent;
      }, 2000);
    } catch (err) {
      console.error('Error adding matching item to cart:', err);
      if (window.showToast) {
        window.showToast('Erro ao adicionar produto à cesta.');
      }
      atcBtn.innerHTML = originalContent;
    } finally {
      atcBtn.disabled = false;
      atcBtn.classList.remove('loading');
    }
  });
}


// 10. Product Recommendations Loader (Native Shopify API Integration)
function initProductRecommendations() {
  const container = document.querySelector('.product-recommendations-wrapper[data-url]');
  if (!container) return;

  const url = container.getAttribute('data-url');
  if (!url) return;

  fetch(url)
    .then(response => response.text())
    .then(text => {
      const html = document.createElement('div');
      html.innerHTML = text;
      const newGrid = html.querySelector('.recommendations-grid');
      if (newGrid && newGrid.children.length > 0) {
        container.innerHTML = '';
        container.appendChild(newGrid);
      }
    })
    .catch(() => {
      // Keep server-side rendered items seamlessly
    });
}